module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "added-order-numbers"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.orderParts), function(parcel, index) {
    return _c('div', {
      staticClass: "order-single-line"
    }, [_c('h4', {
      attrs: {
        "id": "lp"
      }
    }, [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('h4', {
      attrs: {
        "id": "order-number"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcel.ordNumber),
        expression: "parcel.ordNumber"
      }],
      staticClass: "order-number-add-field",
      attrs: {
        "type": "text",
        "name": "orderStartPoint",
        "onfocus": "(this.value == 'Wpisz numer zamówienia') && (this.value = '')",
        "onblur": "(this.value == '') && (this.value = 'Wpisz numer zamówienia')",
        "id": "orderStartPoint"
      },
      domProps: {
        "value": (parcel.ordNumber)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcel, "ordNumber", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "width": "100px"
      },
      attrs: {
        "id": "order-value"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcel.ordValue),
        expression: "parcel.ordValue"
      }],
      staticClass: "order-price-add-field",
      staticStyle: {
        "width": "80px"
      },
      attrs: {
        "type": "text",
        "name": "orderStartPoint",
        "value": "Wpisz wartość zamówienia",
        "onfocus": "(this.value == 'Wpisz wartość zamówienia') && (this.value = '')",
        "onblur": "(this.value == '') && (this.value = 'Wpisz wartość zamówienia')",
        "id": "orderStartPoint"
      },
      domProps: {
        "value": (parcel.ordValue)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcel, "ordValue", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('h4', {
      staticStyle: {
        "width": "75px"
      },
      attrs: {
        "id": "order-weight"
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (parcel.ordWeight),
        expression: "parcel.ordWeight"
      }],
      staticClass: "order-price-add-field",
      staticStyle: {
        "width": "65px"
      },
      attrs: {
        "type": "text",
        "name": "orderStartPoint",
        "value": "Wpisz wagę przesyłki",
        "onfocus": "(this.value == 'Wpisz wagę przesyłki') && (this.value = '')",
        "onblur": "(this.value == '') && (this.value = 'Wpisz wagę przesyłki')",
        "id": "orderStartPoint"
      },
      domProps: {
        "value": (parcel.ordWeight)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(parcel, "ordWeight", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('i', {
      staticClass: "ion-android-cancel clickable",
      on: {
        "click": function($event) {
          return _vm.removePart(index)
        }
      }
    })])
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "35px"
    }
  }, [_c('i', {
    staticClass: "ion-android-add-circle color-blue clickable",
    on: {
      "click": function($event) {
        return _vm.addPart()
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "order-single-line header-single-line"
  }, [_c('h4', {
    attrs: {
      "id": "lp"
    }
  }, [_vm._v("SUMA")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "150px"
    }
  }), _vm._v(" "), _c('h4', {
    staticStyle: {
      "'width": "100px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.partsValueSum) + " zł\n                ")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.partsWeightSum) + " kg\n                ")])])], 2), _vm._v(" "), _c('div', {
    staticClass: "order-info-block"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderPartErrorNum),
      expression: "orderPartErrorNum"
    }],
    staticClass: "error-message",
    staticStyle: {
      "padding-left": "30px"
    },
    attrs: {
      "validation-for": "name5"
    }
  }, [_vm._v("\n                Prosimy o wpisanie numeru zamówienia.\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.orderPartErrorValue),
      expression: "orderPartErrorValue"
    }],
    staticClass: "error-message",
    staticStyle: {
      "padding-left": "30px"
    },
    attrs: {
      "validation-for": "name6"
    }
  }, [_vm._v("\n                Prosimy o wpisanie wartości zamówienia.\n            ")]), _vm._v(" "), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.deliveryParcelsError),
      expression: "deliveryParcelsError"
    }],
    staticClass: "error-message",
    staticStyle: {
      "padding-left": "30px"
    }
  }, [_vm._v("\n                Prosimy o dodanie przynajmniej jednego numeru zamówienia\n                wraz z jego wartością\n            ")]), _vm._v(" "), _c('p')])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-header"
  }, [_c('i', {
    staticClass: "ion-bookmark"
  }), _vm._v(" "), _c('h2', [_vm._v("Dodaj numery i wartości zamówień")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "order-single-line header-single-line"
  }, [_c('h4', {
    attrs: {
      "id": "lp"
    }
  }, [_vm._v("Lp")]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "order-number"
    }
  }, [_vm._v("Nr zamówienia")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "85px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("Wartość")]), _vm._v(" "), _c('h4', {
    staticStyle: {
      "width": "85px"
    },
    attrs: {
      "id": "order-value"
    }
  }, [_vm._v("Waga")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4599b57e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ParcelsBox.vue
// module id = 250
// module chunks = 1